"use strict";module.exports = function () {
  // eslint-disable-next-line max-len,quotes
  return '<symbol id=icon-eek-arrow viewbox="0 0 11 28"><path d="M0 27.75H1.13239C1.76009 27.75 2.35161 27.4145 2.73099 26.8434L10.342 15.3851C10.886 14.5662 10.886 13.4338 10.342 12.6149L2.73099 1.15661C2.35161 0.585476 1.76009 0.25 1.13239 0.25H3.09944e-06" stroke=black stroke-width=1></path></symbol>';
};